import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import CreateIcon from '@mui/icons-material/Create';
import {scrollCSS} from "../../App";
import {addWhiteShade} from "../../services/utills";

// Helper function to create date without timezone issues
const createDate = (year, month, day) => {
    return new Date(Date.UTC(year, month, day));
};

export function MonthView({ startDate, data = [], setStaffData }) {
    const safeData = Array.isArray(data) ? data : [];

    // Use UTC dates to avoid timezone issues
    const monthStart = createDate(startDate.getFullYear(), startDate.getMonth(), 1);
    const monthEnd = createDate(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    const daysInMonth = monthEnd.getDate();
    const firstDayOfWeek = monthStart.getUTCDay() === 0 ? 7 : monthStart.getUTCDay();

    const weeks = [];
    let days = [];

    // Add empty cells for days before the first day of the month
    for (let i = 1; i < firstDayOfWeek; i++) {
        days.push(<TableCell key={`empty-${i}`}>
            <Box sx={{ minHeight: '120px', width: '170px' }}></Box>
        </TableCell>);
    }

    const defaultColor = "#f2f2f2";

    const cellData = (item) => {
        const modifiedColor = item?.color ? addWhiteShade(item?.color) : defaultColor;
        return item?.checkin && item?.checkout && (
            <Box key={item?.id} sx={{
                backgroundColor: modifiedColor,
                color: item?.color,
                mt: '5px',
                display: 'flex',
                p: '5px 10px',
                borderRadius: '5px',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography sx={{fontSize: '10px', fontWeight: "bold"}}>{item?.name}</Typography>
                    <Typography sx={{fontSize: '10px'}}>{item?.checkin}-{item?.checkout}</Typography>
                </Box>
                <Box sx={{display: 'block'}}>
                    <Box sx={{
                        backgroundColor: '#fff',
                        borderRadius: '10px',
                        px: '5px',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }} onClick={() => setStaffData(item)}>
                        <CreateIcon sx={{fontSize: '11px'}}/>
                        <Box sx={{fontSize: '11px', ml: "4px"}}>edit</Box>
                    </Box>
                </Box>
            </Box>
        );
    };

    // Add cells for each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
        const date = createDate(startDate.getFullYear(), startDate.getMonth(), day);
        const dayOfWeek = date.getUTCDay() === 0 ? 7 : date.getUTCDay();

        // Find data for this specific date (timezone-safe comparison)
        const dayData = safeData.find(d => {
            if (!d || !d.date) return false;
            try {
                const dDate = new Date(d.date);
                return dDate.getUTCDate() === day &&
                    dDate.getUTCMonth() === date.getUTCMonth() &&
                    dDate.getUTCFullYear() === date.getUTCFullYear();
            } catch (e) {
                return false;
            }
        }) || { staffs: [] };

        days.push(
            <TableCell key={day}>
                <Box sx={{
                    height: '150px',
                    width: '170px',
                    overflowY: 'auto',
                    ...scrollCSS,
                    "&::-webkit-scrollbar": { width: "0px" },
                }}>
                    <Box>{day}</Box>
                    {dayData.staffs?.map((item) => cellData(item))}
                </Box>
            </TableCell>
        );

        if (dayOfWeek === 7 || day === daysInMonth) {
            weeks.push(<TableRow key={`week-${weeks.length}`}>{days}</TableRow>);
            days = [];
        }
    }

    // Add empty cells for days after the last day of the month if needed
    if (days.length > 0) {
        const remainingCells = 7 - days.length;
        for (let i = 0; i < remainingCells; i++) {
            days.push(
                <TableCell key={`empty-end-${i}`}>
                    <Box sx={{height: '120px', width: '120px'}}></Box>
                </TableCell>
            );
        }
        weeks.push(<TableRow key={`week-end`}>{days}</TableRow>);
    }

    return (
        <TableContainer component={Paper} sx={{boxShadow: 'none'}}>
            <Table sx={{
                boxShadow: 'none',
                "td, th": { border: "1px solid #E0E0E0" }
            }}>
                <TableHead>
                    <TableRow>
                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => (
                            <TableCell key={day} sx={{background: '#fff'}}>{day}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>{weeks}</TableBody>
            </Table>
        </TableContainer>
    );
}